const createNamesLists = (study) => {
    const namesLists = []
    ;(study?.marks || []).forEach((mark, markIndex) => {
        namesLists[markIndex] = []
        const names = mark.namesList || []
        for (let i = 0; i < names.length; i += 1) {
            for (let j = i + 1; j < names.length; j += 1) {
                namesLists[markIndex].push([names[i], names[j]])
            }
        }
    })
    return namesLists
}

const applyStudyTranslation = (study, language) => {
    if (!study) {
        return study
    }

    const requestedLanguage = (language || '').trim().toLowerCase()
    const defaultLanguage = (study.defaultLanguage || 'pl').trim().toLowerCase()
    if (!requestedLanguage || requestedLanguage === defaultLanguage) {
        return study
    }

    const translation = (study.translations || []).find((item) => (
        (item.language || '').trim().toLowerCase() === requestedLanguage
    ))
    if (!translation) {
        return study
    }

    const marksByKey = (translation.marks || []).reduce((accumulator, mark) => {
        if (mark.localKey) {
            accumulator[mark.localKey] = mark
        }
        return accumulator
    }, {})

    return {
        ...study,
        name: translation.name || study.name,
        pages: (study.pages || []).map((page, pageIndex) => {
            const pageTranslation = translation.pages?.[pageIndex] || {}
            return {
                ...page,
                title: pageTranslation.title || page.title,
                text: pageTranslation.text || page.text
            }
        }),
        marks: (study.marks || []).map((mark, markIndex) => {
            const markTranslation = marksByKey[mark.localKey] || translation.marks?.[markIndex] || {}
            const translatedNames = (mark.namesList || []).map((name, nameIndex) => (
                markTranslation.namesList?.[nameIndex] || name
            ))
            return {
                ...mark,
                title: markTranslation.title || mark.title,
                namesList: translatedNames
            }
        })
    }
}

export {
    applyStudyTranslation,
    createNamesLists
}
